import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectVenueExecCapsulesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.VENUE_EXEC_CAPSULE];

export const selectVenueExecCapsuleState = (state: State, widgetKey: string) =>
    selectVenueExecCapsulesState(state)[widgetKey];
